module.exports = __webpack_public_path__ + "img/ajout-danseur.48cfcf8b.svg";